<template>
  <li>
    <div>
      <strong v-if="error.title">{{ error.title }}: </strong>
      <span v-html="error.message"/>
    </div>
    <small 
      v-if="error.details">
      <em>({{ error.details }})</em>
    </small>
  </li>
</template>

<script>
export default {
  props: {
      error: {
          type: Object,
          default: null
      },
  },
  methods: {
  }
}
</script>